import React, { memo, MouseEvent } from 'react';
import styled from 'styled-components';

import { User } from '@/types/userList';
import { CenteredLoader } from '@/components/utils/Loader';
import { FormValues } from '@/components/pages/Users/Index/UserListForm';
import { VirtualizedListContainer } from '@/components/pages/Users/Index/VirtualizedList';

import { Header } from './Header';

type Props = {
  hasUpdateError: (userId: number) => boolean;
  isPreview: boolean;
  isUpdating: boolean;
  isUploading: boolean;
  onCancelClick: (e: MouseEvent<HTMLAnchorElement>) => void;
  onEditLinkClick: (e: MouseEvent<HTMLAnchorElement>, userId: number) => void;
  onUpdateUser: (values: FormValues) => Promise<void>;
  selectedUserId: number | null;
  showUserForm: (index: number) => boolean;
  users: User[] | null;
};

export const List: React.FC<Props> = memo(
  ({
    hasUpdateError,
    isPreview,
    isUpdating,
    isUploading,
    onCancelClick,
    onEditLinkClick,
    onUpdateUser,
    selectedUserId,
    showUserForm,
    users,
  }) => (
    <Wrapper>
      <Header />
      <Div>
        {isUploading && <CenteredLoader />}
        {!isUploading && users && (
          <VirtualizedListContainer
            hasUpdateError={hasUpdateError}
            isPreview={isPreview}
            isUpdating={isUpdating}
            onCancelClick={onCancelClick}
            onEditLinkClick={onEditLinkClick}
            onUpdateUser={onUpdateUser}
            selectedUserId={selectedUserId}
            showUserForm={showUserForm}
            users={users}
          />
        )}
      </Div>
    </Wrapper>
  ),
);

const Wrapper = styled.section`
  background-color: #ffffff;
  margin-bottom: 16px;
  width: 100%;
`;

const Div = styled.div`
  margin-top: -1px;
  max-height: 440px;
  overflow-y: auto;
`;
